export default function DataPolicy() {
  async function deleteAllData() {
    const confirmed = window.confirm(
      "This will permanently delete all stored financial data and revoke bank access. Continue?"
    );

    if (!confirmed) return;

    const res = await fetch("/api/user/delete", { method: "DELETE" });

    if (res.ok) {
      alert("All data deleted successfully.");
      window.location.href = "/";
    } else {
      alert("Failed to delete data.");
    }
  }

  return (
    <div>
      <h2>Data Retention & Deletion</h2><br/>

      <p>
        Financial data is retained only while this application is in use to allow
        transaction review and categorization.
      </p>

      <p>
        Users may permanently delete all stored data at any time using the
        button below. This action is irreversible.
      </p>
<br/><br/>
      <button
        onClick={deleteAllData}
        style={{
          backgroundColor: "black",
          color: "white",
          padding: "10px",
          border: "none",
          cursor: "pointer",
        }}
      >
        Delete All My Data
      </button>
    </div>
  );
}
